import { render, staticRenderFns } from "./TargetPort.vue?vue&type=template&id=3fd36fe6"
import script from "./TargetPort.vue?vue&type=script&lang=js"
export * from "./TargetPort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports